import querystring from 'querystring'

export default class qqAuth {
  constructor (config) {
    const defaultConfig = {
      client_id: '',
      responseType: 'token',
      scope: 'get_user_info'
    }
    this.config = Object.assign(defaultConfig, config)
  }

  getUrlAccessToken (hash) {
    if (!hash) return
    return querystring.parse(hash.replace('#access_token=', 'access_token=')).access_token
  }

  openAuthPage () {
    let url = location.href.split('?')[0]
    // 构建后参数前面自动带了斜杆, 所以去掉最后的斜杆
    url = url.replace(/\/$/g, '')
    url = url + location.search
    const proxyUrl = 'https://pdfvip.ijinshan.com/vip_login_proxy.html?origin=' + url

    // const redirectUri = encodeURIComponent(url)
    const redirectUri = encodeURIComponent(proxyUrl)

    const authPageBaseUri = 'https://graph.qq.com/oauth2.0/authorize'
    const authParams = `?client_id=${this.config.client_id}&response_type=${this.config.responseType}&redirect_uri=${redirectUri}&scope=${this.config.scope}`
    window.location.href = authPageBaseUri + authParams
  }
}
